export function isTDDBrowser (): boolean {
  return !!(typeof window !== 'undefined'
    // @ts-expect-error window
    && (window.VYDIA_SETTINGS?.TDD
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      || window.sessionStorage?.getItem('TDD')))
}
